export interface InterventionNonPreventive {
    id: number;
    objet: string;
    type: string;
    dateDebutPrevue: string;
    dateDebutReelle: string;
    dateFinReelle: string;
    chantierID: number;
    adresseSite: string;
    isAlarmante: boolean;
    etat: EtatsTravaux;
    isRapportPresent: boolean;
}

export enum EtatsTravaux{
    aRealiser = 'A_REALISER',
    enCours = 'EN_COURS',
    realise = 'REALISE'
}
